import {Injectable} from "@angular/core";
import {AbstractControl} from "@angular/forms";
import {Subscription} from "rxjs";

@Injectable()
export class ProjectMarketsServiceProvider {
  private projectMarketsSubscription: Subscription;

  private marketIds: string[];

  public watchMarkets(clientsControl: AbstractControl, marketIds: string[]): string[] {
    if (this.marketIds === undefined) {
      this.marketIds = marketIds;
    }

    if (!this.projectMarketsSubscription) {
      this.projectMarketsSubscription = clientsControl.valueChanges.subscribe(
        (clients) => {
          this.marketIds = this.updateMarketIds(clients, marketIds);
        },
      );
    }

    return this.marketIds;
  }

  public unsubscribeProjectMarkets() {
    if (this.projectMarketsSubscription) {
      this.projectMarketsSubscription.unsubscribe();
      this.projectMarketsSubscription = undefined;
      this.marketIds = undefined;
    }
  }

  private updateMarketIds(
    clients: Array<{ client: { markets: Array<{ name: string }> } }>,
    marketIds: string[]
  ): string[] {
    marketIds = [];
    clients.forEach((client) => {
      if (client && client.client && client.client.markets) {
        client.client.markets.forEach((market) => {
          if (marketIds.indexOf(market.name) < 0) {
            marketIds.push(market.name);
          }
        });
      }
    });

    return marketIds;
  }
}



// WEBPACK FOOTER //
// ./src/modules/projects/services/project-markets.service.ts